module.exports = __webpack_public_path__ + "static/media/error-cross.034eabbd.svg";